import React, { useState, useEffect, useContext, useMemo } from "react";
import { pdfFooter, pdfNotaVenta, pdfCliente, pdfFilasTotales, NOTA_CONDICIONES } from "../../../../pdfUtils";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Seccion, { Totales } from "../../Seccion";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import { makeStyles } from "@material-ui/core/styles";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { encode } from "base64-arraybuffer";
import * as XLSX from "xlsx";
import { calculaDocumento, cargaTasasIEPS, iepsRenglon, num } from "../ieps";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function PedidosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  /* WhatsApp desactivado por ahora
const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
*/

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  let endDate   = moment(date).format("YYYY-MM-DD"); 
  let startDate   = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [idsArticulos, setIdsArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedColaboradorNombre, setSelectedColaboradorNombre] = useState("");
  const [codigoCliente, setCodigoCliente] = useState("");
  const [nombreCliente, setNombreCliente] = useState("");
  const [telefonoCliente, setTelefonoCliente] = useState("");
  const [value, setValue] = useState("");
  const [departamentoCliente, setDepartamentoCliente] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [inventarios, setInventarios] = useState([]);

  const [paqueteria, setPaqueteria] = useState("NA");
  // const [areas, setAreas] = useState([]);
  // const [selectedArea, setSelectedArea] = useState("");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);

  const [fecha, setFecha] = useState(hoy);
  const [fechaInicio, setFechaInicio] = useState(startDate);
  const [fechaCancelacion, setFechaCancelacion] = useState(endDate);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [ieps, setIeps] = useState(0);
  const [tasasIEPS, setTasasIEPS] = useState({});
  const [totalCajas, setTotalCajas] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [descuentoNumero, setDescuentoNumero] = useState(0);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      articulosNombre: "",
      piezasPorCaja: 0,
      cajas: 0,
      cantidad: 0,
      precio: 0,
      total: 0,
      foto:"",
      fotoArticulo: "",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  

  
  
  
  
const [cargando, setCargando] = useState(true);

// Definición de Toast (puede ir fuera del componente si no usa hooks)
const Toast = Swal.mixin({
  toast: true,
  position: "center",
  showConfirmButton: false,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

// Mostrar el Toast al montar
useEffect(() => {
  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`,
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon',
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading(); // opcional para mostrar spinner de Swal
      },
    });
  }
}, [cargando]);

// Cerrar el Toast cuando se complete la carga
useEffect(() => {
  if (!cargando) {
    Swal.close();
  }
}, [cargando]);

useEffect(() => {
  cargaTasasIEPS(URL_ARTICULOS).then(setTasasIEPS).catch((err) => console.log(err));
}, []);

// Lógica de carga de datos
useEffect(() => {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  Promise.all([
    axios.get(`${URL_ARTICULOS}Activos`, { headers }),
    axios.get(`${URL_CLIENTES}GeneralActivos`, { headers }),
    axios.get(URL_COLABORADORES, { headers }),
    axios.get(`${URL_INVENTARIOS}Disponible`, { headers }),
  ])
    .then(([resArticulos, resClientes, resColaboradores, resInventarios]) => {
      const allArticulos = resArticulos.data;
      setArticulos(allArticulos);
      setIdsArticulos(allArticulos.map((a) => a._id));

      setClientes(resClientes.data);
      setColaboradores(resColaboradores.data);
      setInventarios(resInventarios.data);

      setCargando(false);
    })
    .catch((err) => {
      console.log(err);
      setCargando(false); // aunque haya error, cerramos el toast
    });
}, []);


  const savePedido = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();
    let totalPedido = inputFields.length;

    try {
      await axios
        .post(
          URL_PEDIDOS,
          {
            fecha,
            clientes: value._id,
            departamentosClientes: departamentoCliente,
            colaboradores: selectedColaborador,
            total_general: parseFloat(total_general).toFixed(2),
            observaciones,
            total_cantidad,
            paqueteria,
            comisionTDC,
            comisionFlete,
            subTotal: parseFloat(subTotal).toFixed(2),
            ieps: parseFloat(ieps).toFixed(2),
            iva: parseFloat(iva).toFixed(2),
            impuestos: selectedImpuesto,
            surtido: "No",
            autorizadoApartado: "Si",
            autorizadoSurtido: "No",
            editado: "No",
            fechaModificado:fecha,
            creado: user.id,
            fecha_estimada: fecha,
            fecha_entrega: fecha,
            entregaInsumos:"No",
            fechaInicio,
            fechaCancelacion,
            piezasEntregadas: 0,
            piezasPendientes: total_cantidad,
            descuento,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          inputFields.map((a) => {
            if (a.articulos != "" && a.cantidad != 0) {
              axios
                .post(
                  URL_ARTICULOS_PEDIDO,
                  {
                    pedidos: data.data._id,
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    cantidadProcesos: 0,
                    surtido: 0,
                    pendiente_surtir: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio).toFixed(2),
                    total: parseFloat(a.total).toFixed(2),
                    tasaIEPS: num(tasasIEPS[a.articulos]),
                    ieps: iepsRenglon(a.total, tasasIEPS[a.articulos], descuento).toFixed(2),
                    autorizadoSurtido: "No",
                    autorizadoApartado: "Si",
                    clientes: value._id,
                    fecha
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalPedido = totalPedido - 1;
                  if (totalPedido == 0) {
                    enviaMail(data.data.idPedido)
                    WAFOC(data.data.idPedido);
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Pedido",
                          detalle: `${value._id} ${total_general}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then((data) => {
                       
                        Swal.fire("Listo", "Creado con exito", `success`);
                        setTimeout(() => {
                          window.location.reload();
                        }, 3000);
                      });
                  }
                });
            } else {
              totalPedido = totalPedido - 1;
              if (totalPedido == 0) {
                enviaMail(data.data.idPedido)
                WAFOC(data.data.idPedido);
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Pedido",
                      detalle: `${value._id} ${total_general}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then((data) => {
                   
                    Swal.fire("Listo", "Creado con exito", `success`);
                    setTimeout(() => {
                      window.location.reload();
                    }, 3000);
                  });
              }
            }
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Algo salio mal",
            text: "No se pudo completar",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Algo salio mal",
        text: "No se pudo completar",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  async function WAFOC(numero) {
          /* WhatsApp desactivado por ahora
axios
          .post(
            `${URL_WHATSAPP}SendMsg`,
            {
              number: telefonoCliente,
              message:`Hola ${nombreCliente}, hemos recibido tu pedido (${numero}) y comenzaremos a trabajar en él de inmediato para entregarlo lo antes posible. ¡Gracias por tu confianza!`
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem(
                  "app_token"
                )}`,
              },
            }
          ).then((response) => {
            axios
            .post(
              `${URL_WHATSAPP}SendMsg`,
              {
                // number: "5541109490",
                number: "5579232476",
                message:`Hola Alejandro, Se creo el pedido ${numero}`,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            )
          }).catch((error) => {
            console.log(error);
          });
*/         
  }

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        articulosNombre: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        total: 0,
        foto: "",
        fotoArticulo: "",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalCan = values.map((c) => parseFloat(c.cantidad));
    let TC = totalCan.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    recalculaTotales({ lineas: values });
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[name] = value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cajas = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cantidad = event.target.value;
        i.cajas = (parseFloat(event.target.value) / parseFloat(i.piezasPorCaja)).toFixed(2);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, selectedArticulo) {
    if (
      inputFields.filter((e) => e.articulos == selectedArticulo._id).length > 0
    ) {
      Swal.fire({
        icon: "error",
        title: "Algo salio mal",
        text: "El vino ya fue capturado!",
        showConfirmButton: false,
      });
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.articulos = "";
          i.articulosNombre = "";
        }
        return i;
      });
      setInputFields(newInputFields);
    } else {
      articulos.map((a) => {
        if (a._id == selectedArticulo._id) {
          let idArticulo = a._id;
          let piezasPorCaja = a.piezasPorCaja;
          let precio = a.venta;
          let articulosNombre = a.codigo + " " + a.nombre;
          let fotoArticulo = a.foto
          handleChangeInputArticulo(id, idArticulo, piezasPorCaja, precio, articulosNombre, fotoArticulo);
        }
      });
    }
  }

  // function BuscaCodigo(id, event) {
  //   if (event.target.value.length >= 13) {
  //     // if (idsArticulos.includes(event.target.value)) {
  //       articulos.map((a) => {
  //         if (a._id == event.target.value) {
  //           let idArticulo = a._id;
  //         let piezasPorCaja = a.piezasPorCaja;
  //         let precio = a.venta;
  //         let articulosNombre = a.nombre;
  //         handleChangeInputArticulo(id, idArticulo, piezasPorCaja, precio, articulosNombre);
  //         }
  //       });
  //     // } else {
  //     //   Swal.fire({
  //     //     icon: "error",
  //     //     title: "Algo salio mal",
  //     //     text: "El vino no existe",
  //     //     showConfirmButton: false,
  //     //   });
  //     //   const newInputFields = inputFields.map((i) => {
  //     //     if (id === i.id) {
  //     //       i.articulos = "";
  //     //     }
  //     //     return i;
  //     //   });
  //     //   setInputFields(newInputFields);
  //     // }
  //   } else {
  //     const newInputFields = inputFields.map((i) => {
  //       if (id === i.id) {
  //         i.articulos = event.target.value;
  //       }
  //       return i;
  //     });
  //     setInputFields(newInputFields);
  //   }
  // }

function BuscaCodigo(id, event) {
  let valor = event.target.value.trim().slice(0, 24); // máximo 24 caracteres
  const valorEscaneado = valor.toLowerCase();

  if (valorEscaneado.length === 24) {
    const articulo = articulos.find(
      (a) => a._id.toLowerCase() === valorEscaneado
    );

    if (articulo) {
      const idArticulo = articulo._id;
      const piezasPorCaja = articulo.piezasPorCaja;
      const precio = articulo.venta;
      const articulosNombre = articulo.nombre;
      handleChangeInputArticulo(id, idArticulo, piezasPorCaja, precio, articulosNombre);
    } else {
      Swal.fire({
        icon: "error",
        title: "Algo salio mal",
        text: "El vino no existe",
        showConfirmButton: false,
      });

      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.articulos = "";
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  } else {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = valor;
      }
      return i;
    });
    setInputFields(newInputFields);
  }
}



  const handleChangeInputArticulo = (id, idArticulo, piezasPorCaja, precio, articulosNombre, fotoArticulo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        i.precio = precio;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.articulosNombre = articulosNombre;
        i.fotoArticulo = fotoArticulo;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // Un solo calculo de totales: ver ../ieps.js
  function recalculaTotales({
    lineas = inputFields,
    desc = descuento,
    imp = selectedImpuesto,
    tdc = comisionTDC,
    flete = comisionFlete,
  } = {}) {
    const r = calculaDocumento(
      lineas.map((l) => ({ ...l, tasaIEPS: tasasIEPS[l.articulos] })),
      { descuento: desc, impuesto: imp, extras: num(tdc) + num(flete) }
    );
    setSubTotal(r.subTotal);
    setDescuentoNumero(r.descuentoNumero);
    setIeps(r.ieps);
    setIva(r.iva);
    setTotalGeneral(r.total);
  }

  function ActualizaTotales() {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    recalculaTotales();
  }

  function calculaDescuento(e) {
    setDescuento(e);
    recalculaTotales({ desc: e });
  }

  let filteredClientes = clientes;

// Filtrar clientes si user es vendedor
if (user.vendedor === "Si") {
  filteredClientes = clientes.filter(cliente => cliente.vendedor[0].email === user.email);
}

  const options = filteredClientes.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  const options2 = articulos.map((option) => {
    const junta = option.codigo + " " + option.nombre;
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function jalaCliente(selectedCliente) {
    setValue(selectedCliente);

    axios
      .get(`${URL_CLIENTES}/${selectedCliente._id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCliente = res.data;

        setCodigoCliente(allCliente.codigo);
        setNombreCliente(allCliente.nombre_comercial);
        setTelefonoCliente(allCliente.telefono);
        setSelectedColaborador(allCliente.vendedor[0]._id);
        setSelectedColaboradorNombre(allCliente.vendedor[0].nombre + " " + allCliente.vendedor[0].apellido);
        setDepartamentoCliente(allCliente.departamentosClientes[0]._id)
      })
      .catch((err) => {
        console.log(err);
      });

  }



  function calculaImpuesto(e) {
    setSelectedImpuesto(e);
    recalculaTotales({ imp: e });
  }

  function jalaComisionTDC(e) {
    setComisionTDC(e);
    recalculaTotales({ tdc: e });
  }

  function jalaComisionFlete(e) {
    setComisionFlete(e);
    recalculaTotales({ flete: e });
  }

  

  function enviaMail(numero){

      const data = inputFields.map((a) => {
        return {
          foto: a.foto,
          fotoArticulo: a.fotoArticulo,
          articulos: a.articulos,
          articulosNombre: a.articulosNombre,
          cajas: new Intl.NumberFormat("en-US").format(a.cajas),
          cantidad: new Intl.NumberFormat("en-US").format(a.cantidad),
          precio: a.precio,
          total: a.total,
        };
      });
      const dataFinal = Object.values(data);
      // const dataFinalLimpia = dataFinal.filter(function (el) {
      //   return el != null;
      // });



      dataFinal.map(async (z) => {
        if(z.fotoArticulo == "Si"){
        const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${z.articulos}`;
       await axios
          .get(URL_GET_MEDIA, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((data) => {
            if(data.data.secure_url != null){
            z.foto = data.data.secure_url
          }else z.foto = process.env.PUBLIC_URL + "sinImagen.png"
          })
          .catch((err) => {
            console.log(err);
          });
        return z
      }else{
        z.foto = process.env.PUBLIC_URL + "sinImagen.png"
      }
      })

      setTimeout(() => {


      const dataImg = dataFinal.map((a) => {

  

        return [
          a.foto,
          a.articulosNombre,
          new Intl.NumberFormat("en-US").format(a.cantidad) + " Bot. / " + new Intl.NumberFormat("en-US",{maximumFractionDigits: 2}).format(a.cajas) + " Cajas",
          0,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
            
          }).format(a.precio),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
            
          }).format(a.total),
        ];
      });


      const doc = new jsPDF({ compressPdf: true });
      pdfNotaVenta(doc, {
        titulo: "Pedido",
        folio: numero,
        fecha: `Ciudad de México, ${fecha}`,
        cliente: pdfCliente(`${codigoCliente} - ${nombreCliente}`),
        foto: true,
        head: ["Foto", "Vino", "Botellas / Cajas", "Precio", "Importe"],
        body: dataImg.map((f) => [f[0], f[1], f[2], f[5], f[6]]),
        totales: pdfFilasTotales({
          botellas: total_cantidad,
          subTotal,
          descuento: (subTotal * descuento) / 100,
          descuentoPct: descuento,
          flete: comisionFlete,
          ieps,
          iva,
          total: total_general,
        }),
        observaciones,
        condiciones: NOTA_CONDICIONES,
        firmas: ["Confirmado y autorizado por", `Para: ${nombreCliente}`],
      });
      pdfFooter(doc);
      var att = doc.output("arraybuffer");
      var base64File = encode(att);
  
      // Envia el Mail
      axios
        .post(
          URL_SEND_MAIL_ATT,
          {
            subject: `Pedido-${numero}.pdf`,
            email: process.env.REACT_APP_MAIL_ADMIN,
            fileName: `Pedido-${numero}.pdf`,
            att: base64File,
            text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
           <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
           <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
           <tbody>
           <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
           <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Pedido ${numero} del Cliente ${nombreCliente}.</tr>
           </tbody>
           <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
           
           </table>`,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          Swal.fire("Listo", "Enviado con exito", "success");
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Algo salio mal",
            text: "No se pudo completar",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
                },1000)
  }

    function importarArchivo(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];

    if (name === "file") {
      let reader = new FileReader();
      reader.readAsArrayBuffer(target.files[0]);
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (sheetName) {
          // Here is your object
          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          hojas.push({
            data: XL_row_object,
            sheetName,
          });
        });

        let A1 = hojas[0].data;

        // Crear un objeto que mapee los codigo de los artículos a sus objetos correspondientes
        const articulosMap = {};
        inventarios.forEach((articulo) => {
          articulosMap[articulo.codigo] = articulo;
        });

        const articulosNoEncontrados = [];

        // Iterar sobre A1 una sola vez
        for (const a of A1) {
          const articulo = articulosMap[a.Codigo];
          if (articulo) {
            inputFields.push({
              id: uuidv4(),
              articulos: articulo.idArticulo,
              articulosNombre: articulo.nombre,
              piezasPorCaja: 0,
              cajas: 0,
              cantidad: a.Cantidad,
              precio: a.Precio,
              total: a.Precio * a.Cantidad,
              foto: "No",
              fotoArticulo: "No",
            });
          } else {
            // Si no se encuentra el artículo, agregarlo a la lista de no encontrados
              articulosNoEncontrados.push(a.Codigo);
          }
        }

        // Verificar si se encontraron artículos que no estaban en el mapa
        if (articulosNoEncontrados.length > 0) {
          const mensaje = `Los siguientes codigos no se encontraron: ${articulosNoEncontrados.join(
            ", "
          )}`;
          Swal.fire({
            title: "Artículos no encontrados",
            text: mensaje,
            icon: "warning",
            button: "Entendido",
          });
        }

        ActualizaTotales();
      };
    }
  }
  // console.log("hola", inputFields);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <div className="page-header"><div><h3 className="page-title">Nuevo Pedido</h3></div></div>
          {/* <Form > */}
          <Seccion titulo="Cliente" icono="fas fa-user-tie">
<Row>
            <Col md={2}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                disabled
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Cliente</Label>
              <Autocomplete
                size="small"
                value={value}
                onChange={(event, selectedCliente) => {
                  jalaCliente(selectedCliente);
                }}
                options={options.sort(
                  (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                )}
                groupBy={(option) => option.firstLetter}
                getOptionLabel={(option) => option.junta}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Selecciona"
                    variant="outlined"
                  />
                )}
                renderOption={(option) => (
                  <React.Fragment>
                    {option.codigo} {option.nombre_comercial}
                  </React.Fragment>
                )}
              />
            </Col>
            <Col md={2}>
              <Label>Vendedor</Label>
              <Input
                type="select"
                value={selectedColaborador}
                onChange={(e) => {
                  const selectedIndex = e.target.selectedIndex;
                  const selectedOption = e.target.options[selectedIndex];
                  const selectedOptionText = selectedOption.text;
                  setSelectedColaboradorNombre(selectedOptionText);
                  setSelectedColaborador(e.target.value);
                }}
              >
                <option value="">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>

          

            
          </Row>
</Seccion>
<Seccion titulo="Condiciones" icono="fas fa-sliders-h">
<Row>
            {/* <Col md={2}>
              <Label>Surtir de Almacen</Label>
              <Input
                type="select"
                value={selectedArea}
                onChange={(e) => {
                  setSelectedArea(e.target.value);
                  setInputFields([
                    {
                      id: uuidv4(),
                      articulos: "",
                      articulosNombre: "",
                      piezasPorCaja: 0,
                      cajas: 0,
                      cantidad: 0,
                      precio: 0,
                      total: 0,
                    },
                  ])
                }}
              >
                <option value="">Selecciona un almacen</option>
                {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                        })}
              </Input>
            </Col> */}
            <Col md={2}>
              <Label>Descuento %</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={descuento}
                onChange={(e) => {
                  calculaDescuento(e.target.value);
                }}
              />
            </Col>
            
            

            {/* <Col md={1}>
              <Label>Impuestos %</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={selectedImpuesto}
                onChange={(e) => {
                  calculaImpuesto(e.target.value);
                }}
              />
            </Col> */}
              <Col md={1}>
              <Label>Impuestos %</Label>
                <Input
                    type="select"
                    value={selectedImpuesto}
                    required
                    onChange={(e) => {
                      calculaImpuesto(e.target.value);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="16">Si</option>
                    <option value="0">No</option>
                </Input>
            </Col>
            
              
          </Row>
<Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            
          </Row>
</Seccion>
<Seccion titulo="Vinos" icono="fas fa-wine-bottle">
{/* Tabla Articulos */}

          {/* <Form className={classes.root}> */}
          <Row>
            
            <Col md={2}>
              <Label className="mr-sm-2">Buscador</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Articulos</Label>
            </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Disponible</Label>
              </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cajas</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Botellas Por Caja</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Precio</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Total</Label>
            </Col>
          </Row>

          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
              
              <Col md={2}>
              <Autocomplete
                    size="small"
                    value={inputField.articulosNombre}
                    onChange={(event, selectedArticulo) => {
                      BuscaArticulo(inputField.id, selectedArticulo);
                    }}
                    options={options2.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.codigo} {option.nombre}
                      </React.Fragment>
                    )}
                  />
                </Col>
                <Col md={2}>
                  {/* <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value="">Selecciona un Articulo</option>
                    {articulos
                      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre}
                          </option>
                        );
                      })}
                  </Input> */}
                  <Input
                    name="articulo"
                    type="string"
                    placeholder="Articulo"
                    value={inputField.articulosNombre}
                    disabled
                  />
                </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      type="select"
                      disabled
                    >
                      {inventarios
                        .map((a) => {
                          if(inputField.articulos == a.idArticulo){
                          return (
                            <option value={a._id}>
                              {a.disponible}
                            </option>
                          )}
                        })}
                    </Input>
                  </Col>
               
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cajas"
                    type="string"
                    value={inputField.cajas}
                    onChange={(event) =>
                      handleChangeInputCajas(inputField.id, event)
                    }
                  ></Input>
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="piezasPorCaja"
                    type="number"
                    min="0"
                    step="any"
                    value={inputField.piezasPorCaja}
                    required
                    disabled
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInputCantidad(inputField.id, event)
                    }
                  />
                </Col>
                {user.cambiaPrecios ? (
                  <Col md={1}>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      name="precio"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={inputField.precio}
                      className={`form-control-md2`}
                      onValueChange={(value, name) =>
                        handleChangeInputPrecio(value, name, inputField.id)
                      }
                    />
                  </Col>
                ) : <Col md={1}>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      name="precio"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={inputField.precio}
                      className={`form-control-md2`}
                      disabled
                    />
                  </Col>}

                <Col md={1}>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={inputField.total}
                    disabled
                    className={`form-control-md2-disabled`}
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFields}
                    // tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
          {/* </Form> */}
          
</Seccion>
<Seccion titulo="Totales" icono="fas fa-calculator">
<Totales items={[{ t: "Sub Total", v: subTotal }, { t: "Descuento", v: descuentoNumero }, { t: "IEPS", v: ieps }, { t: "IVA", v: iva }, { t: "Total", v: total_general }, { t: "Botellas", v: total_cantidad, n: true }]} />
</Seccion>
{/* Termina Tabla Articulos */}
          <br />
          <div className="form-acciones">
<Button
                href="/ListadoPedidos"
                className="btn btn-secondary"
              >
                Regresar
              </Button>
{validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-primary"
                  tabindex="-1"
                  onClick={savePedido}
                >
                  Guardar
                </Button>
              ) : (
                <Button type="submit" className="btn btn-primary" disabled>
                  Guardar
                </Button>
              )}
</div>


          {/* </Form> */}
          <br />
                  <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios segundos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>

          
        </div>
      ) : undefined}
    </>
  );
}

export default PedidosCreate;
